<template>
  <P1Notifications title="P1 Summations" />
</template>

<script>
import P1Notifications from "@/components/P1Notifications.vue";

export default {
  name: "P1NotificationsView",
  components: {
    P1Notifications
  }
};
</script>
